import { Component, OnInit, OnDestroy, Input, ElementRef, ViewChild } from '@angular/core';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { ChaptersApiService } from '@core/services/chapters-api.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {IPlatformToolComponent, IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { PlatformCommandResponse } from '@shared/commands/command-base';
@Component({
  standalone: false,
  selector: 'cbc-exchange-status',
  templateUrl: './cbc-exchange-status.component.html',
  styleUrls: ['./cbc-exchange-status.component.scss']
})
export class CbcExchangeStatusComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  public unsubscribe$ = new Subject<void>();
  CbcExchangeData: any[] = [];
  CbcExchangeDataCountry1: any[] = [];
  CbcExchangeDataCountry2: any[] = [];
  SelectedCountryName1: string = 'United States';
  SelectedCountryName2: string = 'Anguilla';
  SelectedCountryCode1: string = 'US';
  SelectedCountryCode2: string = 'ET';
  cbcExchangeFiscalYearStartDate: Date;

  ReportPopOverToggle = false;
  country1AccordionOpen = false;
  country2AccordionOpen = false;

  ReportPopOverTogglehasTiea: boolean[] = [];
  ReportPopOverTogglehasTreaty: boolean[] = [];

  private sub = new Subscription();
  constructor(private fuseSplashScreenService: FuseSplashScreenService,private service: ChaptersApiService) { }

  ngOnInit(): void {

    if (this.handler && this.handler.magicLinkModelValueChanged) {
            this.handler.magicLinkModelValueChanged.pipe(takeUntil(this.unsubscribe$))
                .subscribe(item => {
                    if (item.id === 'CbcExchangeStatusComponent') {
                        this.magicLinkModel = item.value;
                    }
                });
        }
    if (this.magicLinkModel) {
      // Extract data from magicLinkModel
      this.SelectedCountryCode1 = this.magicLinkModel.tabBar?.tabs[0]?.tabData['CountryOneCode'] || 'US';
      this.SelectedCountryCode2 = this.magicLinkModel.tabBar?.tabs[0]?.tabData['CountryTwoCode'] || 'ET';
      this.SelectedCountryName1 = this.magicLinkModel.tabBar?.tabs[0]?.tabData['CountryOneName'] || 'United States';
      this.SelectedCountryName2 = this.magicLinkModel.tabBar?.tabs[0]?.tabData['CountryTwoName'] || 'Anguilla';
      this.cbcExchangeFiscalYearStartDate = this.magicLinkModel.tabBar?.tabs[0]?.tabData['FiscalYearStartDate'] 
        ? new Date(this.magicLinkModel.tabBar.tabs[0].tabData['FiscalYearStartDate']) 
        : new Date(Date.now());
    }
     // Load data (choose store or HTTP approach)
    this.fuseSplashScreenService.show();
    this.sub.add(this.service.getCbcExchange(this.SelectedCountryCode1,this.SelectedCountryCode2).subscribe(data => {
      const arr = Array.isArray(data) ? data : [data];
      this.CbcExchangeData = arr.filter(item => {
        const name1 = (item?.countryCode1).toString().trim();
        const name2 = (item?.countryCode2).toString().trim();
        return name1.toLowerCase() === this.SelectedCountryCode1.toLowerCase() &&
          name2.toLowerCase() === this.SelectedCountryCode2.toLowerCase();
      }).map(item => ({...item}))
      .sort((a, b) => (a.countryName2 ?? '').localeCompare(b.countryName2 ?? ''));

      this.CbcExchangeData = this.populateBilateralMultilateralAgreement(this.CbcExchangeData, new Date(this.cbcExchangeFiscalYearStartDate));

      this.CbcExchangeDataCountry1 = arr.filter(item => {
        const name = (item?.countryCode1).toString().trim();
        return name.toLowerCase() === this.SelectedCountryCode1.toLowerCase();
      }).map(item => ({...item}))
      .sort((a, b) => (a.countryName2 ?? '').localeCompare(b.countryName2 ?? ''));
      this.CbcExchangeDataCountry1 = this.populateBilateralMultilateralAgreement(this.CbcExchangeDataCountry1, new Date(this.cbcExchangeFiscalYearStartDate));

      this.CbcExchangeDataCountry2 = arr.filter(item => {
        const name = (item?.countryCode1).toString().trim();
        return name.toLowerCase() === this.SelectedCountryCode2.toLowerCase();
      }).map(item => ({...item}))
      .sort((a, b) => (a.countryName2 ?? '').localeCompare(b.countryName2 ?? ''));
      this.CbcExchangeDataCountry2 = this.populateBilateralMultilateralAgreement(this.CbcExchangeDataCountry2, new Date(this.cbcExchangeFiscalYearStartDate));

      this.ReportPopOverTogglehasTiea = arr.map(() => true);
      this.ReportPopOverTogglehasTreaty = arr.map(() => true);
      this.fuseSplashScreenService.hide();
    }));
  }
  onLoad() { }
  onBeforeExecuteNextCommand(): boolean { return true; }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) { return true; }
  onBeforeExecutePreviousCommand(): boolean { return true; }
  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) { return true; }
  
  populateBilateralMultilateralAgreement(cbcExchangeList, effectiveDate) {
    const toYesNo = (v: any) =>
        (v != null && typeof v.toBool === 'function') ? (v.toBool() ? 'Yes' : 'No') : (v ? 'Yes' : 'No');

    for (var i = 0; i < cbcExchangeList.length; i++) {
      cbcExchangeList[i].hasTreaty = toYesNo(cbcExchangeList[i].hasTreaty);
      cbcExchangeList[i].hasTreatyFootnote = toYesNo(cbcExchangeList[i].hasTreatyFootnote);
      cbcExchangeList[i].hasTiea = toYesNo(cbcExchangeList[i].hasTiea);
      cbcExchangeList[i].hasTieaDoc = toYesNo(cbcExchangeList[i].hasTieaDoc);
      cbcExchangeList[i].hasTieaFootnote = toYesNo(cbcExchangeList[i].hasTieaFootnote);
      cbcExchangeList[i].hasOECD = toYesNo(cbcExchangeList[i].hasOECD);
      cbcExchangeList[i].hasEU = toYesNo(cbcExchangeList[i].hasEU);


      cbcExchangeList[i].cbcBilateralEffectiveFromMessage = "";

      if (cbcExchangeList[i].hasBilateralCbCCompetentAgreement == true && typeof cbcExchangeList[i].cbCBilateralEffectiveDate !== "undefined") {
        var effectiveFromDate = new Date(cbcExchangeList[i].cbCBilateralEffectiveDate);
        if (effectiveDate >= effectiveFromDate) {
          cbcExchangeList[i].bilateralCbCCompetentAgreement = "Yes";
        }
        else {
          cbcExchangeList[i].bilateralCbCCompetentAgreement = "No";
          cbcExchangeList[i].cbcBilateralEffectiveFromMessage = "Effective from " + this.getDateString(effectiveFromDate);
        }
      }
      else {
        cbcExchangeList[i].bilateralCbCCompetentAgreement = "No";
      }

      if (cbcExchangeList[i].hasMultilateralCbCCompetentAuthorityAgreement == true &&
        typeof cbcExchangeList[i].cbCMultilateralEffectiveDate !== "undefined" &&
        effectiveDate >= new Date(cbcExchangeList[i].cbCMultilateralEffectiveDate)) {
        cbcExchangeList[i].multilateralCbCCompetentAuthorityAgreement = "Yes";
      }
      else {
        cbcExchangeList[i].multilateralCbCCompetentAuthorityAgreement = "No";
      }

      if (
        ((cbcExchangeList[i].hasTreaty == "Yes" || cbcExchangeList[i].hasTiea == "Yes") && cbcExchangeList[i].bilateralCbCCompetentAgreement == "Yes") ||
        (cbcExchangeList[i].hasOECD == "Yes" && cbcExchangeList[i].multilateralCbCCompetentAuthorityAgreement == "Yes") ||
        (cbcExchangeList[i].hasEU == "Yes")
      )
        cbcExchangeList[i].exchangeOfCbCReports = "Yes";
      else cbcExchangeList[i].exchangeOfCbCReports = "No";

      if (typeof cbcExchangeList[i].cbCMultilateralEffectiveDate != "undefined" && typeof cbcExchangeList[i].cbCMultilateralFootnote != "undefined") {
        cbcExchangeList[i].cbCMultilateralFootnote = cbcExchangeList[i].cbCMultilateralFootnote.replace("[EFFECTIVE DATE]", this.getDateString(new Date(cbcExchangeList[i].cbCMultilateralEffectiveDate)));
      }
    }

    return cbcExchangeList;
  }
  getDateString(date) {
    return date.getDate() + " " + this.getMonthName(date) + " " + date.getFullYear();
  }
  getMonthName(date) {
    var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return month[date.getMonth()];
  }
  trackByIndex(index: number): number {
    return index;
  }

  popOverShow() { this.ReportPopOverToggle = true; }
  popOverHide() { this.ReportPopOverToggle = false; }

  ngOnDestroy(): void { this.sub.unsubscribe(); }
}